import { Box, Typography } from "@mui/material";
import { SignUpMainLayout } from "./components/Sign-Up";

export const SignUp = () => {
    return (
        <Box>
            <SignUpMainLayout />
        </Box>
    );
};